import { useEffect, useState } from "react";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react"

import Navbar from "./components/NavBar/Navbar.jsx";
import HeroSection from "./components/HeroSection/HeroSection.jsx";
import AboutSection from "./components/AboutSection/AboutSection.jsx";
import ServicesSection from "./components/ServicesSection/ServicesSection.jsx";
import Loader from "./components/Loader/Loader";
import PortfolioSection from "./components/PortfolioSection/PortfolioSection.jsx";
import FooterSection from "./components/FooterSection/FooterSection.jsx";
import MagneticCursor from "./components/MagneticCursor/MagneticCursor.jsx";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1800); // loader duration

    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <div className="App">
      {/* MagneticCursor is my custom cursor component */}
      <MagneticCursor
        color="#40BBd2"
        size={12}
        ringSize={36}
        smoothness={0.12}
      />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <PortfolioSection />
      <FooterSection />
      <Analytics />
      <SpeedInsights />
    </div>
  );
}

export default App;